var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopindustries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.9 23.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f363f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.82,422.34V399.21h-5.39v4.41l-4.63,3v-3.46l-5.4,3.46v-3.46l-6.16,4v15.25h-1.16v.77H356v-.77ZM350.2,400h3.85v9.63H350.2Zm-.77,4.56v5.07H344.8v-2.1Zm-5.4,0v5.07H339.4v-2.1Zm-10,3,4.62-3v5.07H334Zm6.17,14.83v-5.4h3.46v5.4Zm4.24,0v-5.4h3.46v5.4Zm9.63,0h-5.4v-6.17H339.4v6.17H334V410.39h20Z",
    transform: "translate(-332.08 -399.21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.55,415h3.08v-3.08h-3.08Zm.77-2.31h1.54v1.54h-1.54Z",
    transform: "translate(-332.08 -399.21)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.43,415h3.08v-3.08h-3.08Zm.77-2.31h1.54v1.54H350.2Z",
    transform: "translate(-332.08 -399.21)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.49,415h3.08v-3.08h-3.08V415Zm.77-2.31h1.54v1.54h-1.54V412.7Z",
    transform: "translate(-332.08 -399.21)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopindustries);
export default __webpack_public_path__ + "static/media/topindustries.09099bc3a813fb7bbef4a3de493a0ba6.svg";
export { ForwardRef as ReactComponent };